import { CircleInfo } from "@gravity-ui/icons";
import {
  Button,
  Flex,
  Switch,
  Text,
  TextInput,
  Tooltip,
} from "@gravity-ui/uikit";
import {
  Controller,
  useFieldArray,
  useFormContext,
  useWatch,
} from "react-hook-form";

import { RoundingOptionForm } from "../RoundingOptionForm/RoundingOptionForm.tsx";
import css from "./PriceOptionForm.module.scss";

const MAX_PRICE_OPTIONS = 10;

export const PriceOptionsForm = () => {
  const { control } = useFormContext();

  const withoutPrices = useWatch({ control, name: "withoutPrices" });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "priceOptions",
    rules: {
      maxLength: MAX_PRICE_OPTIONS,
    },
  });

  const addPriceOption = () => {
    if (fields.length >= MAX_PRICE_OPTIONS) return;
    append({
      maxPrice: 0,
      multiplier: 1,
      addendum: 0,
    });
  };

  return (
    <div>
      <Controller
        name="withoutPrices"
        control={control}
        render={({ field }) => (
          <Flex
            direction="column"
            gap={1}
            style={{ marginBottom: withoutPrices ? 0 : 16 }}
          >
            <Switch size="m" checked={!!field.value} onUpdate={field.onChange}>
              Выгрузка без цен
            </Switch>
            <Text variant="body-1" color="secondary">
              Источник цен не опрашивается — в фид попадают только каталожные
              данные товара, цены и SKU пустые.
            </Text>
          </Flex>
        )}
      />

      {withoutPrices ? null : (
        <>
          <Flex alignItems="center" gap={2} style={{ marginBottom: 12 }}>
            <Tooltip
              content={
                <div>
                  <div>{"Если <цена> <= <порог>,"}</div>
                  <div>{"то <цена> * <множитель> + <слагаемое>"}</div>
                </div>
              }
              placement="top"
            >
              <Flex tabIndex={0} alignItems="center" gap={1}>
                <CircleInfo />
                <Text variant="body-1" color="secondary">
                  Правила корректировки цены по порогам
                </Text>
              </Flex>
            </Tooltip>
          </Flex>
          {fields.map((field, index) => (
            <div key={field.id} className={css.priceOptionItem}>
              <div>&lt;ЦЕНА&gt;</div>
              <div>&lt;=</div>
              <Controller
                name={`priceOptions.${index}.maxPrice`}
                control={control}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    type="number"
                    placeholder="Max Price"
                    value={
                      field.value !== undefined ? String(field.value) : "0"
                    }
                    onUpdate={(value) =>
                      field.onChange(Math.max(Number(value), 0))
                    }
                    onChange={(event) => {
                      event.preventDefault();
                    }}
                  />
                )}
              />
              <div>*</div>
              <Controller
                name={`priceOptions.${index}.multiplier`}
                control={control}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    type="number"
                    placeholder="Multiplier"
                    value={
                      field.value !== undefined ? String(field.value) : "1"
                    }
                    onUpdate={(value) =>
                      field.onChange(Math.max(Number(value), 0))
                    }
                    onChange={(event) => {
                      event.preventDefault();
                    }}
                  />
                )}
              />
              <div>+</div>
              <Controller
                name={`priceOptions.${index}.addendum`}
                control={control}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    type="number"
                    placeholder="Addendum"
                    value={
                      field.value !== undefined ? String(field.value) : "0"
                    }
                    onUpdate={(value) =>
                      field.onChange(Math.max(Number(value), 0))
                    }
                    onChange={(event) => {
                      event.preventDefault();
                    }}
                  />
                )}
              />
              <Button view="action" selected onClick={() => remove(index)}>
                Удалить
              </Button>
            </div>
          ))}
          <Button
            view="action"
            onClick={addPriceOption}
            disabled={MAX_PRICE_OPTIONS <= fields.length}
          >
            Добавить ценовую вилку
          </Button>

          <RoundingOptionForm />
        </>
      )}
    </div>
  );
};
